<template>
  <div id="functionBoard">
    <div id="page">
      <router-view />
    </div>

    <MessageDialogue v-if="showMessage" />
    <ErrorDialogue v-if="showError" />
    <RegistrationFullDialogue v-if="isRegistrationFull" />

    <Navigation />
  </div>
</template>

<script>
import ErrorDialogue from '@/components/common/ErrorDialogue.vue';
import MessageDialogue from '@/components/common/MessageDialogue.vue';
import RegistrationFullDialogue from '@/components/common/RegistrationFullDialogue.vue';
import Navigation from '@/components/navigation/NavigationIndex.vue';

export default {
  components: {
    Navigation,
    ErrorDialogue,
    MessageDialogue,
    RegistrationFullDialogue,
  },

  computed: {
    showMessage() {
      return this.$store.getters.hasMessage;
    },
    showError() {
      return this.$store.getters.hasError;
    },
    isRegistrationFull() {
      return this.$store.getters.isRegistrationFull;
    },
  },
};
</script>

<style scoped>
#functionBoard {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>
